import React, { Component } from 'react';
import { Link, IndexLink } from 'react-router';

class Sidebar extends Component {
  render() {
    return (
      <aside className="main-sidebar">
        <section className="sidebar">
          <ul className="sidebar-menu">
            <li className="header">Menu Principal</li>
            <li className="active"><IndexLink to="/"><i className="fa fa-home"></i> <span>Início</span></IndexLink></li>
            <li className="treeview">
              <a><i className="fa fa-file-text-o"></i> <span>Protocolo</span>
                <span className="pull-right-container">
                  <i className="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul className="treeview-menu">
                <li><Link to="/protocolo"><i className="fa fa-list-ul"></i> <span>Todas as opções</span></Link></li>
                <li><Link to="/protocolo/consultar"><i className="fa fa-circle-o"></i> <span>Consultar Protocolo</span></Link></li>
              </ul>
            </li>
            <li className="treeview">
              <Link to="/manuais"><i className="fa fa-book"></i> <span>Manuais</span></Link>
            </li>
          </ul>
        </section>
      </aside>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/modulos/layout/Sidebar.js